var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isFormElement } from '../../models';
import { execFormulaAsync } from '../utils/formula.utils';
var FormEventsHandler = /** @class */ (function () {
    function FormEventsHandler(context) {
        var _this = this;
        this.context = context;
        this.pendingErr = new Array();
        this.pendingOk = new Array();
        // execute
        this.execFormulas = function (items) {
            return items.forEach(function (_a) {
                var it = _a.target, formula = _a.formula;
                var target = _this.context.findFormulaDefinition(it.id) || it;
                _this.execFormula({ target: target, formula: formula });
            });
        };
    }
    // pending form api request result
    FormEventsHandler.prototype.handleApiClick = function (_a) {
        var target = _a.target;
        this.pushPendingErr(target);
        this.pushPendingOk(target);
    };
    FormEventsHandler.prototype.pushPendingErr = function (target) {
        var formula = target.frontFormulas.formulaFrontErr;
        if (formula) {
            this.pendingErr.push({ target: target, formula: formula });
        }
    };
    FormEventsHandler.prototype.pushPendingOk = function (target) {
        var formula = target.frontFormulas.formulaFrontOk;
        if (formula) {
            this.pendingOk.push({ target: target, formula: formula });
        }
    };
    FormEventsHandler.prototype.clearPending = function () {
        this.pendingErr = [];
        this.pendingOk = [];
    };
    FormEventsHandler.prototype.onApiErr = function () {
        var pendingErr = this.pendingErr;
        this.clearPending();
        this.execFormulas(pendingErr);
    };
    FormEventsHandler.prototype.onApiOk = function () {
        var pendingOk = this.pendingOk;
        this.clearPending();
        this.execFormulas(pendingOk);
    };
    // local click action
    FormEventsHandler.prototype.handleLocalClick = function (_a) {
        var target = _a.target;
        var formulaFrontClick = target.frontFormulas.formulaFrontClick;
        return this.execFormula({ target: target, formula: formulaFrontClick });
    };
    FormEventsHandler.prototype.execFormula = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var result, target, ok;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!event.formula) return [3 /*break*/, 2];
                        return [4 /*yield*/, execFormulaAsync(event.formula, isFormElement(event.target) ? event.target : null)];
                    case 1:
                        result = _a.sent();
                        target = event.target;
                        ok = this.context.handleChanges(result, target, true);
                        if (!ok && target && target.id) {
                            this.context.handleChange(target.id, result, true);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return FormEventsHandler;
}());
export { FormEventsHandler };
//# sourceMappingURL=form-events-handler.js.map